import type { ErrorInfo, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import ErrorBoundary from "@jkast90/kast-common/error-boundary";
import { logger } from "@jkast90/kast-common/diagnostics";
import { buttonClass } from "@jkast90/kast-common/ui";

const logCrash = (error: Error, info: ErrorInfo) => logger.error(`[Crash] ${error.message}`, info.componentStack ?? "");

/**
 * The shared ErrorBoundary (@jkast90/kast-common) wired to this app's logger and buttons. Report
 * This opens the bug report with the crash note in the navigation state; the
 * move is in-app, so the logs from before the crash go with it.
 */
export default function AppErrorBoundary({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  return (
    <ErrorBoundary
      onError={logCrash}
      onReport={(crashNote) => navigate("/bug-report", { state: { crashNote } })}
      buttonClassName={buttonClass()}
    >
      {children}
    </ErrorBoundary>
  );
}
